export default __webpack_public_path__ + "static/media/samsung-upgrade-preview.84a13880.png";